"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var TableCell_1 = __importDefault(require("@material-ui/core/TableCell"));
var props_1 = require("../../context/props");
var TableCell = function (_a) {
    var row = _a.row, column = _a.column, rowIndex = _a.rowIndex;
    var CellComponent = column.cellComponent, id = column.id, width = column.width;
    var classes = (0, props_1.usePropsContext)().classes;
    var _b = (classes || {}).body, _c = _b === void 0 ? { cell: '' } : _b, _d = _c.cell, classesCell = _d === void 0 ? '' : _d;
    return (react_1.default.createElement(TableCell_1.default, { component: "td", scope: "row", classes: { root: classesCell }, width: width }, !CellComponent
        ? row[id]
        : (react_1.default.createElement(CellComponent, { value: row[id], column: column, rowData: row, cellProps: {}, rowIndex: rowIndex }))));
};
exports.default = TableCell;
